import { getGoogleMapsApiKey } from './stripeConfig';
import { isStripeAutocompleteSupported } from './stripeAutocompleteCountries';

/**
 * Whether to offer our own google places search box above stripe's address form.
 *
 * Stripe's AddressElement only autocompletes in the countries listed in
 * `stripeAutocompleteCountries`, so for the rest we offer a google places search.
 * That search is *only ever an enhancement*: the address form itself is always
 * rendered, so a missing key or an unreachable places API degrades to manual entry.
 *
 * Getting this wrong took card checkout down in FI/MT/RO/AT/LU/DK/SI/SK/LV for four
 * months — the places box had replaced the address form (including the name fields)
 * rather than sitting above it, so a rejected api key left customers with a search
 * box that silently matched nothing and no way to type an address at all.
 */
export function shouldOfferPlacesAutocomplete(country: string): boolean {
  return !isStripeAutocompleteSupported(country) && !!getGoogleMapsApiKey();
}
